const parties = [
  {
    level: -1,
    party: "afs",
    intro: "Alternativ för Sverige",
    description:
      "Det finns bara ett problem med SD, och det är att dom är så jävla PK.",
    color: "rgb(249, 197, 53)",
  },
  {
    level: 0,
    party: "med",
    intro: "Medborgerlig Samling",
    description:
      '"Det Sverigedemokraterna gjorde för varmkorven ska Medborgerlig Samling göra för sushin"\n -Alexander Bard, Samlingsmedborgerlig chefsideolog',
    color: "rgb(43, 79, 122)",
  },
  {
    level: 4,
    party: "pp",
    intro: "Piratpartiet",
    description:
      "Om vi bara får igenom upphävd immaterialrättslag så kommer migrationen lösa sig automatiskt.",
    color: "rgb(81, 36, 131)",
  },
  {
    level: 9,
    party: "fi",
    intro: "Feministiskt Initiativ",
    description: "FEMINISM = ANTI-RASISM",
    color: "rgb(217, 50, 138)",
  },
  {
    level: 10,
    party: "pn",
    intro: "Nyans",
    description:
      "I vissa konservativa frågor så kan du säkert hitta samsyn med SD, men just frågor som gäller Islams plats i samhället känns kanske inte så förhandlingsbara.",
    color: "rgb(237, 124, 48)",
  },
];

export default parties;
